import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { some, cloneDeep } from 'lodash';
import { DialogService } from '../dialog/dialog.service';
import { DSCP_FLOWS } from './common-flow-list/models/model';
export interface DSCP_FLOWS_TYPE {
  name?: string;
  id?: number;
  value?: string;
  checked?: boolean;
  frameSize?: number;
  txInterval?: number;
  padding?: number;
  dfBit?: boolean;
  reflectorUDP?: number;
  nameExist?: boolean;
}

@Component({
  selector: 'nrwl-common-flows-selection',
  templateUrl: './common-flows-selection.component.html',
  styleUrls: ['./common-flows-selection.component.scss']
})
export class CommonFlowsSelectionComponent {
  dataSource = [];
  originalDataSource = [];
  selectAll = false;
  disableAddButton = true;
  searchText: string;
  displayedColumns = ['name'];
  maxSelection = 10;
  overallSelectedFlows = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DSCP_FLOWS_TYPE[],
    public dialogRef: MatDialogRef<CommonFlowsSelectionComponent>,
    private readonly dialogService: DialogService
  ) {
    this.dataSource = data;
    this.originalDataSource = data;
    this.overallSelectedFlows = DSCP_FLOWS.filter(
      element => !data.some(item => element.value === item.value)
    );
  }

  selectAllDscp(): void {
    this.dataSource.forEach((item, index) => {
      item.checked = this.selectAll && index + 1 <= this.maxSelection - 1 ? true : false;
    });
    this.dataSource = cloneDeep(this.dataSource);
    this.disableAddButton = !this.dataSource.some(element => element.checked === true);
  }

  onSearchDscpFlow(text: string): void {
    this.searchText = text;
    const filterData = this.filterData();
    this.dataSource = filterData;
  }

  //eslint-disable-next-line
  selectDscpFlow(row: DSCP_FLOWS_TYPE): void {
    row.checked = !row.checked;
    this.disableAddButton = !this.dataSource.some(element => element.checked);
    const flows = this.dataSource.filter(element => element.checked);
    this.selectAll = flows.length === this.dataSource.length;
  }

  addDscpFlows(): void {
    const filterFlows = this.originalDataSource.filter(item => {
      return item.checked;
    });
    const selectedFlows =
      this.dataSource.filter(element => element.checked).length + this.overallSelectedFlows.length;
    if (selectedFlows > this.maxSelection) {
      this.dialogService.showInfo(
        'information',
        'body',
        'Maximum (10) Flows allowed per reflector',
        'Error - Exceeds Max Flow Limit'
      );
    } else {
      this.dialogRef.close(filterFlows);
    }
  }

  filterData(): Array<[]> {
    if (!this.searchText) {
      return this.originalDataSource;
    }
    const filterText = this.searchText.toLowerCase();

    return this.originalDataSource.filter(data => {
      return some(data, (value, key) => {
        switch (key) {
          case 'value':
            return value.toLowerCase().indexOf(filterText) > -1;
          default:
            return false;
        }
      });
    });
  }
}
